var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10920_102561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.75C11.53 15.75 11.31 15.65 11.15 15.47L9.13 13.06C8.87 12.75 8.48 12.57 8.08 12.57H3.56C1.6 12.57 0 10.94 0 8.94V3.88C0 1.88 1.6 0.25 3.56 0.25H12.45C14.41 0.25 16.01 1.88 16.01 3.88V9.09C16.01 11 14.49 12.56 12.61 12.56L12.55 14.94C12.55 15.28 12.35 15.58 12.03 15.7C11.94 15.73 11.84 15.75 11.75 15.75ZM3.56 1.46C2.25 1.46 1.19 2.55 1.19 3.88V8.93C1.19 10.27 2.25 11.35 3.56 11.35H8.08C8.83 11.35 9.54 11.68 10.03 12.27L11.36 13.85V12.62C11.36 11.92 11.92 11.35 12.61 11.35C13.83 11.35 14.82 10.34 14.82 9.09V3.88C14.82 2.54 13.76 1.46 12.45 1.46H3.56Z",
    fill: "#717274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49001 7.01H3.56001C3.23001 7.01 2.97001 6.74 2.97001 6.4C2.97001 6.06 3.24001 5.79 3.56001 5.79H8.50001C8.83001 5.79 9.09001 6.06 9.09001 6.4C9.09001 6.74 8.82001 7.01 8.50001 7.01H8.49001ZM5.53001 4.49H3.55001C3.22001 4.49 2.96001 4.22 2.96001 3.88C2.96001 3.54 3.23001 3.27 3.55001 3.27H5.53001C5.86001 3.27 6.12001 3.54 6.12001 3.88C6.12001 4.22 5.85001 4.49 5.53001 4.49Z",
    fill: "#717274"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10920_102561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4257204701402ef6afb758eac7f7669f.svg";
export { ForwardRef as ReactComponent };